import React from "react";
import Background from "@/components/landing/Background";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import HowItWorks from "@/components/landing/HowItWorks";
import AfterRegistration from "@/components/landing/AfterRegistration";
import LiveNumbers from "@/components/landing/LiveNumbers";
import Results from "@/components/landing/Results";
import BudgetProtection from "@/components/landing/BudgetProtection";
import ForWhom from "@/components/landing/ForWhom";
import PersonalBenefit from "@/components/landing/PersonalBenefit";
import Pricing from "@/components/landing/Pricing";
import Comparison from "@/components/landing/Comparison";
import FAQ from "@/components/landing/FAQ";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function Landing() {
    return (
        <div className="relative min-h-screen" data-testid="landing-page">
            <Background />
            <div className="relative z-10">
                <Navbar />
                <main>
                    <Hero />
                    <Marquee />
                    <HowItWorks />
                    <AfterRegistration />
                    <LiveNumbers />
                    <Results />
                    <BudgetProtection />
                    <ForWhom />
                    <PersonalBenefit />
                    <Pricing />
                    <Comparison />
                    <FAQ />
                    <FinalCTA />
                </main>
                <Footer />
            </div>
        </div>
    );
}
